<mat-toolbar class="mainNavbar">
  <div
    class="mainNavbar_item mainNavbar_item--logoWrapper"
    [routerLink]="['/']"
  >
    <svg
      class="mainNavbar-logoImg"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 842.8 93"
    >
      <g>
        <path d="M340.5,0h4.3v93.4h-4.3V0z" />
        <path d="M0,17.3h8v51.1h19.2v8H0V17.3z" />
        <path
          d="M102.6,17.4h8.1v36.3c0,5.4,1.3,9.5,3.9,12.5c2.6,2.9,6.2,4.4,11,4.4c4.7,0,8.3-1.3,11-4c2.7-2.7,4-6.5,3.9-11.4V17.4h8.1
		      v37.2c0,7.2-2.1,13-6.2,17.3c-4.1,4.3-9.6,6.5-16.5,6.5c-7,0-12.6-2.2-16.9-6.6s-6.3-10.9-6.3-19.4L102.6,17.4z"
        />
        <path d="M161.9,17.3H198v8.1h-14.1v51h-8v-51h-14V17.3z" />
        <path
          d="M211.8,17.3h32.8v8.1h-24.8v14.8h24.8v8h-24.8v20.3h24.8v8h-32.8V17.3z"
        />
        <path
          d="M307,19.4v9.1c-6.4-3.1-12.2-4.7-17.6-4.7c-6.4-0.2-12.7,2.2-17.4,6.6c-4.6,4.2-7.2,10.1-7.1,16.3
		      c-0.1,6.3,2.5,12.3,7.2,16.5c4.8,4.4,10.8,6.6,18.1,6.6c5.3,0,10.8-1.7,16.7-5V74c-5.4,2.8-11.3,4.3-17.4,4.3
		      c-8.8,0.2-17.2-3.2-23.5-9.3c-6.3-5.7-9.8-13.9-9.7-22.4c-0.1-8.4,3.4-16.4,9.6-22c6.2-6,14.5-9.3,23.1-9.2
		      C295.3,15.5,301.3,16.9,307,19.4z"
        />
        <polygon
          points="65.9,15 61.7,24.3 65.9,33.5 65.9,33.5 75.4,54.6 48.1,54.6 45.1,61.3 53.4,61.3 78.5,61.3 85.3,76.4 93.8,76.4"
        />
      </g>
      <g>
        <path
          d="M444.5,14.9l43.7,44.9V17.3h8.1v61.8l-43.7-44.7v42h-8.1V14.9z"
        />
      </g>
      <path d="M578.8,17.3h8v51.1h19.3v8h-27.2L578.8,17.3L578.8,17.3z" />
      <path
        d="M665.2,17.3h36.1v8.1h-14.1v51h-8v-51h-14.1L665.2,17.3L665.2,17.3z"
      />
      <path d="M716.3,17.3h8v59.1h-8V17.3z" />
      <path
        d="M840.7,23.8l-6.5,5.2c-1.7-1.8-3.3-3.1-4.7-4s-3.4-1.3-6.1-1.3c-2.9,0-5.3,0.7-7.1,2c-1.8,1.3-2.7,3-2.7,5.1
	      c0,1.8,0.8,3.4,2.4,4.7c1.6,1.4,4.3,2.9,8.1,4.5c3.8,1.6,6.8,3.1,8.9,4.6c2.1,1.4,3.9,3,5.2,4.7c1.3,1.7,2.4,3.5,3,5.4s1,3.9,1,6
	      c0,4.9-1.8,9.1-5.4,12.6s-7.9,5.2-13,5.2c-4.9,0-9.3-1.4-13.1-4.1c-3.8-2.7-6.7-6.8-8.7-12.2l8.1-2.3c2.9,6.6,7.4,10,13.5,10
	      c2.9,0,5.4-0.9,7.3-2.6c1.9-1.8,2.9-4,2.9-6.7c0-1.6-0.5-3.2-1.5-4.8s-2.3-3-3.8-4s-3.9-2.3-7.2-3.6c-3.3-1.4-5.9-2.6-7.6-3.7
	      c-1.8-1.1-3.3-2.5-4.6-4c-1.3-1.6-2.3-3.1-2.9-4.7c-0.6-1.5-0.9-3.2-0.9-5c0-4.2,1.7-7.8,5.1-10.8s7.5-4.5,12.4-4.5
	      c3.2,0,6.5,0.7,9.8,2.1C835.8,18.8,838.5,20.9,840.7,23.8z"
      />
      <g>
        <path
          d="M748.2,69c6.5,6.2,14.3,9.3,23.5,9.3c6.2,0,12-1.4,17.4-4.3v-9.2c-5.9,3.3-11.4,5-16.7,5c-7.2,0-13.3-2.2-18.1-6.6
		      c-3.7-3.4-6-7.5-6.8-12.3h-8.7C739.6,57.8,742.7,63.8,748.2,69z"
        />
        <path
          d="M771.3,23.7c5.3,0,11.2,1.6,17.6,4.7v-9.1c-6.2-2.6-12.2-3.9-18-3.9c-9,0-16.7,3.1-23.1,9.2c-5.4,5.2-8.5,11.3-9.4,18.3
		      h8.7c0.8-4.8,3-8.9,6.7-12.4C758.7,25.9,764.5,23.7,771.3,23.7z"
        />
      </g>
      <g>
        <polygon points="536.3,33.5 536.3,33.5 538.2,37.6" />
        <polygon
          points="536.3,15 532.1,24.3 545.9,54.6 526.8,54.6 531.9,43.3 527.7,34.1 508.7,76.4 517,76.4 523.8,61.3 548.9,61.3
		      555.8,76.4 564.2,76.4"
        />
        <line fill="none" x1="532.1" y1="24.3" x2="532.1" y2="24.3" />
        <line fill="none" x1="532.1" y1="24.3" x2="532.1" y2="24.3" />
      </g>
      <g>
        <path
          d="M609.9,17.3h8.9l14.5,23.8l14.4-23.8h8.9l-19.4,32v27.1h-8.1v-27L609.9,17.3z"
        />
      </g>
      <g>
        <polygon
          points="405.7,15 391.5,46.5 399.8,46.5 405.6,33.5 415.2,54.6 401.2,54.6 396.2,54.6 387.8,54.6 378,76.4 386.4,76.4
		      393.2,61.3 418.2,61.3 425.1,76.4 433.6,76.4"
        />
      </g>
    </svg>
  </div>
  @if (displayReportPicker()) {
    <div class="mainNavbar_item mainNavbar_item--reportPickerWrapper">
      <!-- h-100 is necessary because reports picker has no logo -->
      <app-report-picker
        class="h-100"
        [reports]="reports().entities"
        [selectedReportId]="selectedReportId()"
        [disabled]="pickersDisabled()"
        (selected)="selectReport($event)"
      />
    </div>
  }

  <div class="mainNavbar_item mainNavbar_item--rightSide">
    @if (selectedAccount(); as selectedAccount) {
      <div class="modulePicker" [matMenuTriggerFor]="modulesMenu">
        <button mat-button title="Module picker" data-cy="module-picker-button">
          <mat-icon svgIcon="apps" class="icon--large" />
        </button>

        <mat-menu
          #modulesMenu="matMenu"
          class="m-2 modulePickerMatMenu"
          xPosition="before"
        >
          <ng-template matMenuContent>
            @if (modules().entities) {
              <div class="modules">
                <!-- Modules with access -->
                @for (module of modulesWithAccess; track module) {
                  <div
                    class="modules_item"
                    mat-menu-item
                    [attr.data-cy]="`${module.name}-menu-option`"
                    (click)="navigateToModule(module)"
                  >
                    <div class="moduleDetails">
                      <img
                        [src]="module.favIconUrl"
                        [alt]="module.name || 'Module icon'"
                      />
                      <div>
                        <span>{{ module.name }}</span>
                        <div class="text-muted">
                          <span>{{ module.description }}</span>
                        </div>
                      </div>
                    </div>

                    <div class="activeModule">
                      <mat-icon svgIcon="check" />
                      <span>Active</span>
                    </div>
                  </div>
                }

                <!-- Core module -->
                <div
                  class="modules_item"
                  mat-menu-item
                  (click)="navigateToModule(CoreModule)"
                >
                  <div class="moduleDetails">
                    <img
                      [src]="CoreModule.favIconUrl"
                      [alt]="CoreModule.name || 'Core Module Fav icon'"
                    />
                    <div>
                      <span>{{ CoreModule.name }}</span>
                      <div class="text-muted">
                        <span>{{ CoreModule.description }}</span>
                      </div>
                    </div>
                  </div>

                  <div class="activeModule">
                    <mat-icon svgIcon="check" />
                    <span>Active</span>
                  </div>
                </div>

                <!-- Modules without access -->
                @for (module of modulesWithoutAccess; track module) {
                  <div
                    class="modules_item"
                    mat-menu-item
                    (click)="navigateToModule(module)"
                  >
                    <div class="moduleDetails">
                      <img
                        [src]="module.favIconUrl"
                        [alt]="module.name || 'Module icon'"
                      />
                      <div>
                        <span>{{ module.name }}</span>
                        <div class="text-muted">
                          <span>{{ module.description }}</span>
                        </div>
                      </div>
                    </div>

                    <div class="noAccessModule">
                      <span>Find out more</span>
                    </div>
                  </div>
                }
              </div>
            } @else {
              <div class="text-muted p-3">
                <i>No apps available</i>
              </div>
            }
          </ng-template>
        </mat-menu>
      </div>

      <div class="userProfile">
        <button
          mat-button
          class="text-initial"
          [matMenuTriggerFor]="menu"
          (click)="onUserProfileMenuTriggered()"
        >
          <app-account-signature
            [account]="selectedAccount"
            [onlyAvatar]="true"
            [displayTooltip]="false"
          />
          <div class="d-flex align-items-center">
            <div class="userProfile_info d-flex flex-column text-start ms-2">
              <span class="text-start text-truncate">
                {{ selectedAccount?.firstName }} {{ selectedAccount?.lastName }}
              </span>

              @if (clients(); as clients) {
                @if (selectedClientId(); as selectedClientId) {
                  <span class="text-small text-muted text-truncate">
                    {{
                      selectedAccount?.client?.name ??
                        (
                          clients.entities
                          | findByProperty: 'id' : selectedClientId
                        )?.name
                    }}
                  </span>
                }
              }
            </div>

            <mat-icon class="iconRight" svgIcon="menu-down" />
          </div>
        </button>

        <mat-menu #menu="matMenu" xPosition="before" class="m-2">
          <div class="userProfile_accountSection">
            <app-account-signature
              [account]="selectedAccount"
              [onlyAvatar]="true"
              [displayTooltip]="false"
            />

            <div>
              {{ selectedAccount?.firstName }} {{ selectedAccount?.lastName }}
            </div>
            <div class="text-small text-muted">{{ user()?.email }}</div>

            <a (click)="navigateToMyAccount(selectedAccount)">
              <span>My Account</span>
            </a>
          </div>

          @if (displayAccountPicker()) {
            <div class="accountPicker">
              <app-account-picker
                [accounts]="user()?.accounts ?? []"
                [selectedAccountId]="selectedAccount.id"
                (selected)="selectAccount($event)"
              />
            </div>
          }
          @if (displayClientPicker()) {
            <div class="clientPicker">
              <app-client-picker
                [clients]="clients().entities"
                [selectedClientId]="selectedClientId()"
                (selected)="selectClient($event)"
              />
            </div>
          }

          <button
            mat-menu-item
            class="userProfile_signOutBtn"
            (click)="signOut()"
          >
            <mat-icon svgIcon="logout" />
            <span>Sign out</span>
          </button>
        </mat-menu>
      </div>
    } @else {
      <button mat-button class="userProfile_signOutBtn" (click)="signOut()">
        <mat-icon svgIcon="logout" />
        <span>Sign out</span>
      </button>
    }
  </div>
</mat-toolbar>
